import { render, staticRenderFns } from "./ApprovalType.vue?vue&type=template&id=03d639b2&"
import script from "./ApprovalType.vue?vue&type=script&lang=ts&"
export * from "./ApprovalType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports